var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 51,
    viewBox: "0 0 48 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.27 10.0126L33.7074 30.8649L16.4087 13.5227L37.27 10.0126Z",
    fill: "url(#paint0_linear_1_205)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 28,
    r: 15,
    fill: "url(#paint1_linear_1_205)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7615 20C12.2342 20 11.7343 20.2364 11.3997 20.6439C11.0653 21.0519 10.9308 21.5881 11.034 22.1052C11.4582 24.2334 12.6287 27.9687 15.83 31.1701C19.0313 34.3715 22.7666 35.5419 24.8948 35.9661C25.4119 36.069 25.9481 35.9349 26.3561 35.6001C26.7636 35.2659 27 34.766 27 34.2386V31.398C27 30.9659 26.7368 30.5772 26.3356 30.4169L23.6872 29.3573C23.2948 29.2005 22.8463 29.2925 22.5472 29.5912L21.1616 30.9771C21.045 31.0937 20.8636 31.1138 20.7244 31.026C20.1136 30.6185 19.0225 29.8434 18.0897 28.9105C17.1568 27.9777 16.3818 26.8867 15.9775 26.2776C15.8879 26.1388 15.9076 25.9563 16.0243 25.8397L16.025 25.839C16.4248 25.4371 17.0352 24.8265 17.409 24.4531C17.7078 24.154 17.7998 23.7055 17.6429 23.3131L16.5834 20.6647C16.4231 20.2634 16.0344 20.0002 15.6023 20.0002L12.7615 20ZM12.7615 20.7045H15.6021C15.7461 20.7045 15.8757 20.7923 15.9289 20.9262L16.9886 23.5746C17.0407 23.7053 17.0101 23.8551 16.9104 23.9544C16.5366 24.3285 15.9257 24.9394 15.5253 25.3416C15.174 25.6933 15.1159 26.2431 15.3864 26.6614L15.3886 26.6645C15.8095 27.2982 16.6184 28.4354 17.5913 29.4085C18.5641 30.3812 19.7009 31.19 20.3336 31.6124L20.3377 31.6148C20.7563 31.8861 21.3073 31.8276 21.6598 31.4749C22.0607 31.0738 22.6713 30.4633 23.0454 30.0895C23.1447 29.9898 23.2945 29.9591 23.4252 30.0113L26.0736 31.071C26.2075 31.1242 26.2952 31.2538 26.2952 31.3978V34.2383C26.2952 34.5547 26.1532 34.8544 25.9088 35.0553C25.6643 35.2561 25.3423 35.3367 25.032 35.2748C22.989 34.8679 19.4017 33.7454 16.328 30.6717C13.2544 27.5981 12.132 24.0108 11.7247 21.9677C11.6631 21.6574 11.7438 21.3354 11.9442 21.0908C12.1451 20.8461 12.4448 20.7045 12.7615 20.7045Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_205",
    x: 0,
    y: 10.0125,
    width: 41.27,
    height: 40.9875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_205"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_205",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_205",
    x1: 35.5,
    y1: 19.5,
    x2: 7.22755,
    y2: 25.3912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED0CBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD2C79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_205",
    x1: 4,
    y1: 27.6667,
    x2: 34,
    y2: 27.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD2C79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED0CBD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.49061ac6ada736ed8a40163a1a10532f.svg";
export { ForwardRef as ReactComponent };